import React, { useState } from 'react';
import { Shield, MessageCircle, CheckCircle, X, TrendingUp, Award } from 'lucide-react';
import { Link } from 'react-router-dom';
import RegistrationModal from './RegistrationModal';

const ReadyToSecureCTA = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState('registration');

  const openModal = (type) => {
    setModalType(type);
    setIsModalOpen(true);
  };

  return (
    <>
      <RegistrationModal 
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        initialType={modalType}
      />
    <div className="py-16 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gradient-to-br from-gray-900 via-[#1a1a1a] to-black text-white rounded-3xl px-8 py-12 md:px-12 md:py-16">
          {/* Main CTA Content */}
          <div className="text-center mb-8">
            <h2 className="text-4xl md:text-5xl font-bold mb-4">
              Ready to Secure These Benefits?
            </h2>
            <p className="text-lg text-gray-300 max-w-2xl mx-auto">
              Don't wait until it's too late. Start protecting your brand today and enjoy all these advantages.
            </p>
          </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
          <button
            onClick={() => openModal('registration')}
            className="group flex items-center justify-center bg-gradient-to-r from-[#FF6B35] to-[#FF8C42] hover:from-[#FF8C42] hover:to-[#FF6B35] text-white font-bold px-8 py-4 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg shadow-[#FF6B35]/30"
          >
            <Shield className="w-5 h-5 mr-2" />
            Start Registration
            <span className="ml-2 group-hover:translate-x-1 transition-transform duration-300">→</span>
          </button>
          
          <button
            onClick={() => openModal('attorney')}
            className="group flex items-center justify-center border-2 border-white/30 hover:border-white text-white font-semibold px-8 py-4 rounded-lg transition-all duration-300 hover:bg-white/10"
          >
            <MessageCircle className="w-5 h-5 mr-2" />
            Discuss with Attorney
            <span className="ml-2 text-green-400">●</span>
          </button>
        </div>

        {/* Trust Indicators */}
        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center text-sm">
          <div className="flex items-center gap-2">
            <CheckCircle className="w-5 h-5 text-green-400" />
            <span className="text-gray-300">Free Consultation</span>
          </div>
          <div className="hidden sm:block text-gray-600">•</div>
          <div className="flex items-center gap-2">
            <CheckCircle className="w-5 h-5 text-green-400" />
            <span className="text-gray-300">No Hidden Fees</span>
          </div>
          <div className="hidden sm:block text-gray-600">•</div>
          <div className="flex items-center gap-2">
            <CheckCircle className="w-5 h-5 text-green-400" />
            <span className="text-gray-300">24-Hour Response</span>
          </div>
        </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default ReadyToSecureCTA;
